import { PackageX } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { MaterialDispositionPage } from './pages/MaterialDispositionPage'

/**
 * Material Disposition Board — v1 (2026-08-12).
 *
 * Tracks material that becomes non-sellable (damaged, lost, quarantined,
 * off-spec, expired/near-expiry, recalled) from the moment it's found
 * through to a remediation outcome (write-off, vendor claim, return to
 * vendor, insurance claim, internal-use downgrade, customer goodwill
 * credit, or release back to sellable stock). Odoo interaction is
 * read-only in v1 — the actual scrap/adjustment/return/claim happens as
 * a manual Odoo step; ops marks the case resolved on the board with a
 * reference note. Mirrors Returns/RMA's v1 scoping decision.
 *
 * Entry point is manual creation in this module only — no CARLA chat
 * tool in v1.
 */
export default defineModule({
  id: 'material-disposition',
  name: 'Material Disposition',
  shortName: 'Disposition',
  icon: PackageX,
  navSection: 'warehouse',
  navOrder: 12,
  urlNamespace: '/material-disposition',
  routes: [{ path: '/', element: MaterialDispositionPage, label: 'Material Disposition' }],
  permissions: ['admin', 'operations', 'purchasing', 'finance'],
  densityDefault: 'comfortable',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g m d',

  commandPaletteEntries: [
    {
      label: 'Go to Material Disposition',
      keywords: ['damaged', 'lost', 'quarantined', 'write-off', 'disposition', 'scrap', 'claim'],
      path: '/',
      group: 'modules',
      shortcut: 'g m d',
    },
    {
      label: 'New Material Disposition Case',
      keywords: ['new case', 'damaged material', 'write off', 'quarantine'],
      path: '/?action=new',
      group: 'actions',
    },
  ],
})
